import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from "react";
import { IframeDetail, VfModal } from "@vfit/shared/components";
export var ModalIframeWrapper = function() {
    var initialIframe = {
        title: "",
        url: "",
        onClose: function() {}
    };
    var setModalHeight = function() {
        return 563;
    };
    var ref = useState(false), showModal = ref[0], setShowModal = ref[1];
    var ref1 = useState(initialIframe), modalDetail = ref1[0], setModalDetail = ref1[1];
    if (typeof document !== "undefined") {
        document.addEventListener("iframeServiceNotificationEvent", function(event) {
            var detail = event.detail;
            setModalDetail(detail || modalDetail);
            setShowModal(!showModal);
        });
    }
    var resetModalStatus = function() {
        setModalDetail(initialIframe);
        setShowModal(false);
    };
    var handleCloseModal = function() {
        if (modalDetail.onClose) modalDetail.onClose();
        resetModalStatus();
    };
    return /*#__PURE__*/ _jsx(VfModal, {
        wrapperId: modalDetail.id,
        height: setModalHeight(),
        isOpen: showModal,
        handleClose: handleCloseModal,
        children: /*#__PURE__*/ _jsx(IframeDetail, {
            title: modalDetail.title || initialIframe.title,
            url: modalDetail.url || initialIframe.url
        })
    });
};
